
import { defineComponent, PropType } from "vue";
import { SkillProgress } from "@/types";
import rules from "@/shared/constants/rules";
import { ModalWindow } from "@/shared/ui";
import { EditSkill, RollSkillDice } from "@/features";

export default defineComponent({
	name: "Skill",
	components: { EditSkill, RollSkillDice, ModalWindow },
	emits: ["update", "remove"],
	rules: rules,
	props: {
		skill: {
			type: Object as PropType<SkillProgress>,
			required: true,
		},
	},
	data() {
		return {
			editMode: false,
		};
	},
	computed: {
		experiencePercent() {
			const percent =
				(this.skill.experience /
					this.$options.rules.LEVEL_CUPS[this.skill.level - 1]) *
				100;
			return percent > 100 ? 100 : percent;
		},
	},
	methods: {
		update(skill: SkillProgress) {
			this.$emit("update", skill);
		},
		remove() {
			this.$emit("remove");
		},
	},
});
